import { render } from "./ContactoForm.vue?vue&type=template&id=8369afa0&scoped=true"
import script from "./ContactoForm.vue?vue&type=script&lang=js"
export * from "./ContactoForm.vue?vue&type=script&lang=js"

import "./ContactoForm.vue?vue&type=style&index=0&id=8369afa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8369afa0"]])

export default __exports__